import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import image from '../images/man.png'

import instagram from '../images/social-media/instagram.png'
import facebook from '../images/social-media/facebook.png'
import twitter from '../images/social-media/twitter.png'

import './contact-me.css'

const SecondPage = () => (
    <Layout>
        <SEO title="Contact Me" />

        <div className="box-wrapper">
            <div className="box-top">
                <img src={image} alt="Sagar Giri"className="image"/>
            </div>
            <div className="name">Sagar Giri</div>
            <div className="email">sagargiri8846@gmail.com</div>
            <div className="box-bottom">
               <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/sktuts_/"> <img src={instagram}  alt="instagram contact"/>   Instagram<br/></a>
               <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/SkTuts"> <img src={twitter}   alt="twitter contact"/>    Twitter<br/></a>
               <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/sa.k.50309277"> <img src={facebook}   alt="facebook contact"/>   Facebook<br/></a>
               
            </div>

        </div>
        
     <br/><br/>
        <br/><br/>
    </Layout>
)

export default SecondPage
